// IT Support invoices bill KaribuNet's technicians deployed at client
// hospitals: one line per hospital per month, e.g.
//   "Provision of IT Technicians deployed at JITIMAI District Hospital for the month of AUGUST"
// Each hospital is a product in the HOSPITAL_CATEGORY category on the
// Products & Price List page (its price is the monthly fee). On an IT Support
// invoice the line items editor shows Hospital + Month per line and writes
// the description itself, so the wording is always exactly this.

export const IT_SUPPORT_TYPE = "IT Support";
export const HOSPITAL_CATEGORY = "IT Support";

const MONTHS = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

// "August 2026" -> "AUGUST"; "" when no month is chosen yet.
export const monthWord = (serviceMonth) => {
  const m = String(serviceMonth || "").trim().split(/\s+/)[0];
  return MONTHS.some((name) => name.toLowerCase() === m.toLowerCase()) ? m.toUpperCase() : "";
};

export const itSupportDescription = (hospital, serviceMonth) =>
  `Provision of IT Technicians deployed at ${hospital || "…"} for the month of ${monthWord(serviceMonth) || "…"}`;

export const isHospitalProduct = (product) =>
  String(product?.category || "").trim().toLowerCase() === HOSPITAL_CATEGORY.toLowerCase();

// Month choices: 2 months ahead back to 12 months ago, newest first, e.g.
// "August 2026". Stored as the label itself so it reads well everywhere.
export const serviceMonthOptions = (today = new Date()) => {
  const out = [];
  for (let offset = 2; offset >= -12; offset -= 1) {
    const d = new Date(today.getFullYear(), today.getMonth() + offset, 1);
    out.push(`${MONTHS[d.getMonth()]} ${d.getFullYear()}`);
  }
  return out;
};

// Reads hospital + month back out of a line written before this editor
// existed (e.g. invoice 00015/IT: "...deployed at JITIMAI District Hospital
// for September"). The month gets its most recent past-or-current year.
const LEGACY = /deployed at (.+?) for (?:the month of )?([A-Za-z]+)\s*$/i;
export const parseItSupportDescription = (description, today = new Date()) => {
  const m = LEGACY.exec(String(description || "").trim());
  if (!m) return null;
  const word = monthWord(m[2]);
  const options = serviceMonthOptions(today).slice(2); // current month and older
  const serviceMonth = word ? options.find((o) => monthWord(o) === word) || "" : "";
  return { hospital: m[1].trim(), service_month: serviceMonth };
};

// Converts a catalog price into the invoice's currency. Returns null when it
// can't be converted safely (no rate yet) -- never a guess.
export const priceInCurrency = (price, productCurrency, invoiceCurrency, rate) => {
  const p = Number(price) || 0;
  const from = productCurrency === "USD" ? "USD" : "TZS";
  const to = invoiceCurrency === "USD" ? "USD" : "TZS";
  if (from === to) return p;
  const r = Number(rate);
  if (!(r > 0)) return null;
  return from === "USD" ? Math.round(p * r) : Math.round((p / r) * 100) / 100;
};
